/**
 * Closed host registry for the reusable care-note period export.
 * Adding a page later is one row here plus a <CareNoteExportControl /> mount.
 * An unknown host id is rejected by the server action.
 */

export const CARE_NOTE_EXPORT_HOSTS = {
  'client-case-notes': {
    label: 'Case notes',
    modulePath: '/clients',
    clientScope: 'fixed',
    offersUnnotedVisits: true,
    defaultRangeDays: 28,
  },
  'notes-review': {
    label: 'Note review',
    modulePath: '/home-care/notes-review',
    clientScope: 'visible-caseload',
    offersUnnotedVisits: true,
    defaultRangeDays: 28,
  },
} as const;

export type CareNoteExportHostId = keyof typeof CARE_NOTE_EXPORT_HOSTS;

export type CareNoteExportHost = (typeof CARE_NOTE_EXPORT_HOSTS)[CareNoteExportHostId];

export function isCareNoteExportHostId(value: unknown): value is CareNoteExportHostId {
  return typeof value === 'string' && value in CARE_NOTE_EXPORT_HOSTS;
}

export function getCareNoteExportHost(host: string): CareNoteExportHost | null {
  if (!isCareNoteExportHostId(host)) return null;
  return CARE_NOTE_EXPORT_HOSTS[host];
}

export function careNoteExportPreferenceKey(host: CareNoteExportHostId): string {
  return `statura.care-note-export.v1.${host}`;
}
